import styled from 'styled-components/native';
import style, { hpx } from './../../styles/index';

export const PriceSelectorContainer = styled.View`
  padding: 0 20px;
  margin-bottom: 20px;
`;

export const PriceContainer = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${hpx(16)} 0;
  border-bottom-width: 1px;
  border-bottom-color: #f0f0f0;
`;

export const PriceTitle = styled.Text`
  font-size: ${style.fonts.medium};
  font-family: ${style.fontName.ubuntuRegular};
  color: #333;
`;

export const PriceRadio = styled.View`
  background-color: ${props =>
    props.selected ? props.theme.colors.primary : 'transparent'};
  border: 1.5px solid ${props => props.selected ? props.theme.colors.primary : '#ccc'};
  width: ${hpx(22)};
  height: ${hpx(22)};
  border-radius: ${hpx(11)};
`;

export const Label = styled.Text`
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
  color: #333;
  margin-bottom: ${hpx(10)};
`;
